import { PageData } from '@/gem.types';

interface Props {
  element: any;
  theme: PageData['theme'];
  mediaEndpoint: string;
}

const ImageGemElement = ({ element, mediaEndpoint }: Props) => {
  const { gem } = element;
  const image = `${mediaEndpoint}/${gem?.optimized || gem.image}`;

  return (
    <div className="w-full mb-8">
      <img
        src={image}
        alt={gem.name || 'Image'}
        className="w-full object-cover"
        style={{
          zIndex: 1,
          cursor: 'pointer'
        }}
        onClick={() => window.open(image, '_blank')}
      />
    </div>
  );
};

export default ImageGemElement;
